import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupInfo } from "@/features/study-group-info/components/StudyGroupInfo";

export const Route = createFileRoute("/study-group/$study-group-id/info")({
  component: StudyGroupInfo,
});
